import store from '../store'

export default {
    // host: 'http://web.hiphop.top/',
    host: 'https://www.vhiphop.com/api/',
    imgHost: 'https://vhiphop-img.oss-cn-beijing.aliyuncs.com/',
    videoHost: 'https://vhiphop-video-raw.oss-cn-beijing.aliyuncs.com/',// 转码前的oss地址
    videoOutputHost: 'https://vhiphop-video-output.oss-cn-beijing.aliyuncs.com/',// 转码后的oss地址
    imgCdn: 'https://img.vhiphop.com/',
    captchaImgHost: 'https://www.vhiphop.com/api/img-captcha',

    //GET请求
    get(url, data = null) {
        // return this.ajax('GET', url, null);
        return this.fetch('GET', url, data);
    },

    //POST请求
    post(url, data = null) {
        return this.fetch('POST', url, data);
    },

    // PUT全部更新
    put(url, data = null) {
        return this.fetch('PUT', url, data);
    },

    // PATCH 局部更新
    patch(url, data = null) {
        return this.fetch('PATCH', url, data);
    },

    //Delete请求
    del(url, data = null) {
        return this.fetch('DELETE', url, data);
    },

    /*ajax(method, url, data) {
        return new Promise((resolve, reject) => {

            let xhr = new XMLHttpRequest, {user} = store.state, params = [];
            xhr.responseType = 'json';

            xhr.onload = () => {
                switch (xhr.status) {
                    case 200: resolve(xhr.response);break;
                    case 204: resolve();break;
                    case 401:// 401登录失败处理
                        user.id = 0; window.localStorage.user = '';
                        let {msg} = store.state;
                        msg.err_msg = '登录已过期, 请重新登录';
                        msg.err_show = true;
                        setTimeout(() => msg.err_show = false, 2000);
                    break;
                    default: reject({status: xhr.status, res: xhr.response});
                }
            };
            //判断是否存在data对象
            if (data) {
                //对特殊字符串进行URIComponent编码
                for (let k in data) params.push(`${encodeURIComponent(k)}=${encodeURIComponent(data[k])}`);
                data = params.join('&');
            }
            xhr.open(method, url, true);
            xhr.withCredentials = true; //支持跨域发送cookies
            xhr.send(data);
        });
    },*/

    putFile(host, token, now, blob, progress = false) {
        return new Promise((resolve, reject) => {
            let xhr = new XMLHttpRequest;

            if (progress) {
                xhr.upload.onprogress = e => e.lengthComputable && progress(e);// 侦听方法
            }
            xhr.onload = () => xhr.status === 200 ? resolve() : reject();
            xhr.open('PUT', host, true);// 启动PUT请求
            xhr.setRequestHeader('Authorization', token);// 设置Auth头部信息 用于验证授权
            xhr.setRequestHeader('x-oss-date', now);// 因为无法设置Date头部信息 所以使用x-oss设置请求时间 GMT格式
            xhr.send(blob);// 发送图片文件
        });
    },

    delFile(host, token, now) {
        let del = new XMLHttpRequest;
        del.open('DELETE', host, true);// 启动一个DELETE请求
        del.setRequestHeader('Authorization', token);// 设置Auth头部信息 用于验证授权
        del.setRequestHeader('x-oss-date', now);// 因为无法设置Date头部信息 所以使用x-oss设置请求时间 GMT格式
        del.send(null);// 发送DELETE请求
    },

    fetch(method, url, data) {
        let {user} = store.state;
        let init = {
            method,
            mode: 'cors',
            headers: {
                'Content-Type': 'application/json',
                'X': '',
            },
            credentials: 'include',
        };

        if (user.id) {
            data = data || {};
            data.uid = user.id;
            data.token = user.token;
        }

        // 将数据拼接成表单形式的键值对
        if (data) {
            if (method === 'GET' || method === 'DELETE') {
                let params = [];
                Object.keys(data).forEach((k) => {
                    params.push(`${encodeURIComponent(k)}=${encodeURIComponent(data[k])}`);
                });
                url += '?' + params.join('&');
            } else {
                init.body = JSON.stringify(data);
            }
        }


        return fetch(url.includes('http') ? url : `${this.host}${url}`, init).then(e => {
            switch (e.status) {
                case 200: return e.json();
                case 204: break;
                case 401:// 401登录失败统一处理
                    user.id = 0;
                    window.localStorage.user = '';
                    let {sign} = store.state;
                    /*msg.err_msg = '登录已过期, 请重新登录';
                    msg.err_show = true;
                    setTimeout(() => msg.err_show = false, 3000);*/
                    sign.sign_box_show = true;
                    return Promise.reject({status_code: 401, message: '登录已过期, 请重新登录'});
                case 403: return e.json().then(e => Promise.reject(e));// 服务端主动抛出错误
                default: return Promise.reject({status_code: 500, message: '服务器繁忙, 请稍后再试'});
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/api/index.js